import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage } from "@/comn/hooks";
import { BASE, URLS, APIS, SG_USR_DTL_LIST } from "@/tra/tancis/ptli/prcsmntr/intusr/service/PtliIntUsrPrcsService";

/*
 * Detailed inquiry of internal user account processing status
 * !== 내부 사용자 계정처리현황 상세 조회 ==!
 */
export const PTLI0601002Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const { usrDmnId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        usrSrchDtlList: useGrid({
            defaultSchema: SG_USR_DTL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get the list of internal user account processing status. !== 내부 사용자 계정처리현황 상세 목록을 조회한다. ==!
        getUsrDtlList: useFetch({
            api: (page = grid.usrSrchDtlList.page) =>
                APIS.getIntUsrPrcsHistList(usrDmnId, page, grid.usrSrchDtlList.size),
            enabled: comnUtils.isEmpty(usrDmnId),
            key: [grid.usrSrchDtlList.page, grid.usrSrchDtlList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    page: grid.usrSrchDtlList.page,
                    size: grid.usrSrchDtlList.size,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {
                            navigate(URLS.ptli0601001q);
                        },
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00025" }); // Failed to select. !== 조회가 실패하였습니다. ==!
            },
        }),
    };

    /*
     * Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getUsrDtlList.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.usrSrchDtlList.grid} data={fetch.getUsrDtlList.data?.intUsrHistList} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            navigate(`${URLS.ptli0601001q}`);
                        }}
                    >
                        {t("B_PRE")}
                    </Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
